import React from "react";

import LoadingIcon from "../../loading-icon/loading-icon";
import { Box } from "../../theme/containers";
import { PcaSubHeading } from "../../theme/typography";

const JourneyLoading = () => {
    return (
        <Box textAlign="center" className="u-my-17">
            {/* @ts-ignore */}
            <LoadingIcon size="medium" />
            <PcaSubHeading>Loading your personalised journey...</PcaSubHeading>
        </Box>
    )
};

export default JourneyLoading;
